"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UpdaterBanner_1 = __importDefault(require("./UpdaterBanner"));
exports.default = UpdaterBanner_1.default;
